<div class="pointer-events-none absolute inset-0" aria-hidden="true">
  @for (bulb of bulbs(); track $index) {
    <span
      class="absolute size-5 -translate-1/2 rounded-full transition-[filter,box-shadow] duration-1200 motion-reduce:animate-none"
      [class]="bulbClass()"
      [style.left.px]="bulb.x"
      [style.top.px]="bulb.y"
      [style.--i]="$index"
      [style.--phase]="bulb.phase"
    ></span>
  }
</div>
<ng-content />
